<template>
  <div>
    <div class="display--flex align--center">
      <p class="paragraph--small bold mb--1" v-if="label">
        {{ label }}
      </p>
      <div
        :class="[
          'dropdown__wrapper',
          isOpened ? 'dropdown__wrapper--open' : '',
        ]"
        v-click-outside="close"
      >
        <p
          :class="[
            'dropdown__selected',
            isOpened ? 'dropdown__selected--open' : '',
          ]"
          @click="toggleDropdown"
        >
          {{ selectedValue ? selectedValue : "Выберите из списка" }}
          <img
            src="../../assets/icons/arrow-down.svg"
            alt=""
            class="dropdown__icon"
          />
        </p>
        <ul :class="['dropdown__list', isOpened ? 'dropdown__list--open' : '']">
          <template v-for="(option, index) in options">
            <li
              :class="[
                'dropdown__item',
                selectedValue == option ? 'dropdown__item--active' : '',
              ]"
              @click="selectOption(option)"
            >
              {{ option }}
            </li>
          </template>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      required: true,
    },
    value: {
      type: [String, Number],
    },
    options: {
      type: Array,
    },
  },
  data() {
    return {
      selectedValue: null,
      isOpened: false,
    };
  },
  computed: {
    restSelects() {
      return this.options
        .filter(
          (el, idx, arr) => el != this.selectedValue && arr.indexOf(el) == idx
        )
        .sort((a, b) => a - b);
    },
  },
  destroyed() {
    this.selectedValue = null;
  },
  methods: {
    toggleDropdown() {
      this.isOpened = !this.isOpened;
    },
    selectOption(option) {
      this.selectedValue = option;
      this.isOpened = false;
      this.$emit("input", this.selectedValue);
    },
    close() {
      this.isOpened = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.dropdown {
  &__wrapper {
    cursor: pointer;
    position: relative;
    border: 1px solid #eaeaea;
    box-sizing: border-box;
    border-radius: 20px;
    width: fit-content;
    min-width: 220px;
    &--open {
      border-radius: 20px 20px 0px 0px;
    }
  }
  &__icon {
    transform: scale(0.7);
    margin-left: 0.6rem;
  }
  &__selected {
    color: #31343b;
    font-size: 16px;
    padding: 12px 18px;
    display: flex;
    justify-content: space-between;
    color: #515151;
    font-size: 14px;

    &--open {
      color: #3367a2;
    }
    &:focus {
      color: #1d4676;
    }
    &:hover {
      color: #3367a2;
    }
  }
  &__list {
    list-style: none;
    background: white;
    width: 100%;
    border: 1px solid #eaeaea;
    border-radius: 0px 0px 20px 20px;
    border-top: 0;
    display: none;
    position: absolute;
    overflow: hidden;
    top: 100%;
    left: 0;
    &--open {
      display: block;
    }
  }
  &__item {
    font-weight: 400;
    font-size: 14px;
    color: #31343b;
    cursor: pointer;
    width: 100%;
    padding: 10px 18px;
    transition: all 0.3s;
    &--light {
      color: white;
    }
    &--active {
      background: #0082be;
      color: white;
    }
    &:hover {
      color: #3367a2;
      background: #9bd9f5;
    }
  }
}
</style>
